class Api {
  constructor(axios) {
    this.axios = axios
  }

  // authors
  getAuthors = async (per_page, page) => await this.axios.get(`/authors/?per_page=${per_page}&page=${page}`);

  getAuthor = async (authorSlug) => await this.axios.get(`/authors/${authorSlug}`);

  createAuthor = async (data) => await this.axios.post('/authors', data);

  updateAuthor = async (id, data) => await this.axios.put(`/authors/${id}`, data);

  deleteAuthor = async (id) => await this.axios.delete(`/authors/${id}`);

  // issues
  getIssues = async (per_page, page, withPieces=false) => await this.axios.get(`/issues/?per_page=${per_page}&page=${page}${withPieces ? '&withPieces=true' : ''}`);

  getIssueWithPieces = async (id, withIds=false) => await this.axios.get(`/issues/${id}${withIds ? '?withIds=true' : ''}`);

  createIssue = async (data) => await this.axios.post('/issues', data);

  updateIssue = async (id, data) => await this.axios.put(`/issues/${id}`, data);

  deleteIssue = async (id) => await this.axios.delete(`/issues/${id}`);

  // pieces
  getPieces = async (per_page, page) => await this.axios.get(`/pieces?per_page=${per_page}&page=${page}`);

  getPiece = async (id, contentOnly) => await this.axios.get(`/pieces/${id}${contentOnly ? '?contentOnly=true' : ''}`);

  createPiece = async (data) => await this.axios.post('/pieces', data);
  
  updatePiece = async (id, data) => await this.axios.put(`/pieces/${id}`, data);

  updatePieceContent = async (id, data) => await this.axios.put(`/pieces/${id}/content`, data);

  deletePiece = async (id) => await this.axios.delete(`/pieces/${id}`);

  // blocks
  getBlocks = async (per_page, page) => await this.axios.get(`/blocks/?per_page=${per_page}&page=${page}`);

  getBlock = async (id) => await this.axios.get(`/blocks/${id}`);

  createBlock = async (data) => await this.axios.post('/blocks', data);

  updateBlock = async (id, data) => await this.axios.put(`/blocks/${id}`, data);

  deleteBlock = async (id) => await this.axios.delete(`/blocks/${id}`);

  // users
  getUsers = async (per_page, page) => await this.axios.get(`/users/?per_page=${per_page}&page=${page}`);

  getUser = async (id) => await this.axios.get(`/users/${id}`);

  createUser = async (data) => await this.axios.post('/users', data);

  updateUser = async (id, data) => await this.axios.put(`/users/${id}`, data);

  deleteUser = async (id) => await this.axios.delete(`/users/${id}`);

  login = async (data) => await this.axios.post('/users/login', data);

  search = async (term) => await this.axios.get(`/search?term=${term}`);

  // books
  getBooks = async (per_page, page) => await this.axios.get(`/books/?per_page=${per_page}&page=${page}`);

  createBook = async (data) => await this.axios.post('/books', data);

  updateBook = async (id, data) => await this.axios.put(`/books/${id}`, data);

  deleteBook = async (id) => await this.axios.delete(`/books/${id}`);

  // about
  getAbout = async () => await this.axios.get('/about');

  createAbout = async (data) => await this.axios.post('/about', data);

  updateAbout = async (id, data) => await this.axios.put('/about', data);

  // menu pages
  getMenuPages = async () => await this.axios.get('/menu');

  updateMenuPage = async (id, data) => await this.axios.put(`/menu/${id}`, data);

  // manage
  exportData = async () => await this.axios.get('/manage/export-data', {responseType: 'blob'});

  // contact
  getContacts = async () => await this.axios.get('/contacts');

  createContact = async (data) => await this.axios.post('/contacts', data);

  updateContact = async (id, data) => await this.axios.put(`/contacts/${id}`, data);

  deleteContact = async (id) => await this.axios.delete(`/contacts/${id}`);

  // drafts
  getDraft = async (id) => await this.axios.get(`/drafts/${id}`);

  createDraft = async (data) => await this.axios.post('/drafts', data);

  deleteDraft = async (id) => await this.axios.delete(`/drafts/${id}`);
}

export default Api;